import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/posgo-app/Dashboard/Index.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Password from "../views/Password.vue";
import NotFound from "../views/NotFound.vue";
// Componentes POSGO-APP
import Clients from "../views/posgo-app/Clients/Index.vue";
import ClientCreate from "../views/posgo-app/Clients/Create.vue";
import ClientEdit from "../views/posgo-app/Clients/Edit.vue";
import Loans from "../views/posgo-app/Loans/Index.vue";
import LoanCreate from "../views/posgo-app/Loans/Create.vue";
import LoanView from "../views/posgo-app/Loans/View.vue";
import Products from "../views/posgo-app/Products/Index.vue";
import ProductView from "../views/posgo-app/Products/View.vue";
import ProductCreate from "../views/posgo-app/Products/Create.vue";
import Units from "../views/posgo-app/Configs/Products/Units/Index.vue";
import UnitCreate from "../views/posgo-app/Configs/Products/Units/Create.vue";
import UnitView from "../views/posgo-app/Configs/Products/Units/View.vue";
import Categories from "../views/posgo-app/Configs/Products/Categories/Index.vue";
import CategoryCreate from "../views/posgo-app/Configs/Products/Categories/Create.vue";
import CategoryView from "../views/posgo-app/Configs/Products/Categories/View.vue";
import Company from "../views/posgo-app/Configs/Company/Index.vue";
import Users from "../views/posgo-app/Configs/Users/Index.vue";
import UsersCreate from "../views/posgo-app/Configs/Users/Create.vue";
import UsersView from "../views/posgo-app/Configs/Users/View.vue";
import RolesView from  "../views/posgo-app/Configs/Users/Roles.vue";
import PaymentCreate from "../views/posgo-app/Payments/Create.vue";
import Invoices from "../views/posgo-app/Invoices/Index.vue";
import InvoiceView from "../views/posgo-app/Invoices/View.vue";
import InvoiceCreate from "../views/posgo-app/Invoices/Create.vue";
import CreditNotes from "../views/posgo-app/Invoices/NCIndex.vue";
import CreditNoteView from "../views/posgo-app/Invoices/NCView.vue";
import CreditNoteCreate from "../views/posgo-app/Invoices/NCCreate.vue";
import InvoiceReports from "../views/posgo-app/Reports/Invoices.vue";

const routes = [
    {
        path: "/",
        name: "/",
        component: Dashboard,
    },
    {
        path: "/dashboard-default",
        name: "Dashboard",
        component: Dashboard,
    },
    //Settings
    {
        path: "/settings/company",
        name: "Ajuste de empresa",
        component: Company,
    },
    //Users
    {
        path: "/settings/users",
        name: "Usuarios",
        component: Users,
    },
    {
        path: "/settings/users/create",
        name: "Registrar Usuario",
        component: UsersCreate,
    },
    {
        path: "/settings/users/:id",
        name: "Editar Usuario",
        component: UsersView,
    },
    {
        path: "/settings/users/roles",
        name: "Roles",
        component: RolesView,
    },
    //Clients
    {
        path: "/clients",
        name: "Clientes",
        component: Clients,
    },
    {
        path: "/clients/create",
        name: "Crear Cliente",
        component: ClientCreate,
    },
    {
        path: "/clients/:id",
        name: "Ver Cliente",
        component: ClientEdit,
    },
    //Loans
    {
        path: "/loans",
        name: "Créditos",
        component: Loans,
    },
    {
        path: "/create-loan/:id",
        name: "Crear Crédito",
        component: LoanCreate,
    },
    {
        path: "/view-loan/:id",
        name: "Ver Crédito",
        component: LoanView,
    },
    //Products
    {
        path: "/products",
        name: "Productos",
        component: Products,
    },
    {
        path: "/products/create",
        name: "Crear producto",
        component: ProductCreate,
    },
    {
        path: "/products/:id",
        name: "Ver Producto",
        component: ProductView,
    },
    //Units
    {
        path: "/settings/units",
        name: "Unidades de Medida",
        component: Units,
    },
    {
        path: "/settings/units/create",
        name: "Crear Unidad de Medida",
        component: UnitCreate,
    },
    {
        path: "/settings/units/view/:id",
        name: "Ver Unidad de Medida",
        component: UnitView,
    },
    //Categories
    {
        path: "/settings/categories",
        name: "Categorías",
        component: Categories,
    },
    {
        path: "/settings/categories/create",
        name: "Crear Categoría",
        component: CategoryCreate,
    },
    {
        path: "/settings/categories/view/:id",
        name: "Ver Categoría",
        component: CategoryView,
    },
    //Invoices
    {
        path: "/invoices",
        name: "Facturas",
        component: Invoices,
    },
    {
        path: "/invoices/:id",
        name: "Detalle de Factura",
        component: InvoiceView,
    },
    {
        path: "/invoices/create",
        name: "Crear Factura",
        component: InvoiceCreate,
    },
    //Credit Notes
    {
        path: "/invoices/credit_notes",
        name: "Notas de Crédito",
        component: CreditNotes,
    },
    {
        path: "/invoices/credit_note/:id",
        name: "Detalle de Nota de Crédito",
        component: CreditNoteView,
    },
    {
        path: "/invoices/credit_note/create",
        name: "Crear Nota de Crédito",
        component: CreditNoteCreate,
    },
    //Reports
    {
        path: "/reports/invoices",
        name: "Reportes de Facturación",
        component: InvoiceReports,
    },
    //Payments
    {
        path: "/create-payment/:id",
        name: "Crear pago",
        component: PaymentCreate,
    },
    //
    {
        path: "/tables",
        name: "Tables",
        component: Tables,
    },
    {
        path: "/billing",
        name: "Billing",
        component: Billing,
    },
    {
        path: "/virtual-reality",
        name: "Virtual Reality",
        component: VirtualReality,
    },
    {
        path: "/rtl-page",
        name: "RTL",
        component: RTL,
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
    },
    {
        path: "/signin",
        name: "Signin",
        component: Signin,
    },
    {
        path: "/password",
        name: "Password",
        component: Password,
    },
    {
        path: "/signup",
        name: "Signup",
        component: Signup,
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    linkActiveClass: "active",
});

export default router;